/* JPassport shared runtime. No PII logging.
   Classic (non-module) script — may be loaded from more than one section;
   the window.JPassport guard makes double-loading safe.
   Horizon morphs cart-section HTML after AJAX cart mutations (morphSection in
   section-renderer.js), which wipes JS-rendered widgets: mount functions are
   registered here and re-run after every cart update. Each mount self-guards
   with a data-jp-mounted attribute so untouched elements no-op. */
(function () {
  'use strict';
  if (window.JPassport) return;
  var callbacks = [];
  var mounts = [];

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = String(str == null ? '' : str);
    return d.innerHTML;
  }

  function remountAll() {
    mounts.forEach(function (fn) {
      try { fn(); } catch (e) { /* isolate module failures */ }
    });
  }

  function notifyCartUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        callbacks.forEach(function (cb) {
          try { cb(cart); } catch (e) { /* isolate */ }
        });
        setTimeout(remountAll, 150); // let the section morph settle first
      })
      .catch(function () { /* network error: keep last state */ });
  }

  // Detect cart mutations regardless of how the theme performs them.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { notifyCartUpdate(); }, function () {});
    }
    return p;
  };

  window.JPassport = {
    esc: esc,
    onCartUpdate: function (cb) { callbacks.push(cb); },
    registerMount: function (fn) {
      mounts.push(fn);
      try { fn(); } catch (e) { /* isolate */ }
    },
    refreshCart: notifyCartUpdate
  };

  // skip_login scrub — relative replaceState only, never a cross-origin URL
  // (the legacy theme's hardcoded-domain pushState threw SecurityError).
  var params = new URLSearchParams(window.location.search);
  if (params.has('skip_login')) {
    params.delete('skip_login');
    var qs = params.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }
})();

/* Rewards dashboard module.
   Field names verified against the live API (docs/jpassport/API_SAMPLES.md):
   vip-tier → { point_balance, loyalty_spent_amount,
                loyalty_perks_by_brand: [{ tier, name(=perk text),
                spent_amount_required, reached_level, progress_percentage }] }
   rewards  → { user.point_balance, rewards: [{ name, points_required,
                total_quantity(-1=unlimited), availability("1"/"0"),
                display_start/end("YYYY-MM-DD HH:MM:SS"), avatar,
                shopify_discount_code, slug, id, redeemable, hide_redeem }] } */
(function () {
  'use strict';
  window.JPassport.registerMount(function mountRewards() {
    var root = document.querySelector('[data-jp-rewards]');
    if (!root || root.dataset.jpMounted === '1') return;
    root.dataset.jpMounted = '1';
    var esc = window.JPassport.esc;
    var t = JSON.parse(root.dataset.jpT);
    var q = 'email=' + encodeURIComponent(root.dataset.jpEmail) + '&user_id=' + encodeURIComponent(root.dataset.jpUserId);
    var api = root.dataset.jpApi;

    function fmt(str, vars) {
      return str.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
    }
    function show(sel, html) {
      var el = root.querySelector(sel);
      if (!el) return;
      el.innerHTML = html;
      el.hidden = false;
    }
    // API dates are SQL-style "YYYY-MM-DD HH:MM:SS" — Date.parse chokes on
    // that in Safari (primary mobile audience). Normalize to ISO first.
    function parseDate(v) { return v ? Date.parse(String(v).replace(' ', 'T')) : NaN; }

    function tierName(x) {
      var n = x.tier || 'MEMBER';
      return n === 'MEMBER' ? 'BASIC' : n;
    }
    function badgeFor(x) {
      var n = x.tier || 'MEMBER';
      if (n === 'GOLD') return root.dataset.jpBadgeGold;
      if (n === 'SILVER') return root.dataset.jpBadgeSilver;
      return root.dataset.jpBadgeMember;
    }

    // 1) VIP tier + progress
    fetch(api + '/api/shopify/get-vip-tier?' + q + '&vendor_name=' + encodeURIComponent(root.dataset.jpVipVendor))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tiers = (data.loyalty_perks_by_brand || []).slice().sort(function (a, b) {
          return (a.spent_amount_required || 0) - (b.spent_amount_required || 0);
        });
        if (!tiers.length || tiers[0].spent_amount_required > 0) {
          tiers.unshift({ tier: 'MEMBER', spent_amount_required: 0, reached_level: true });
        }
        var current = tiers[0];
        tiers.forEach(function (x) { if (x.reached_level) current = x; });
        var spent = Number(data.loyalty_spent_amount || 0);
        // API `name` is the perk sentence (e.g. "Gold Member: 10% OFF every Monday & Tuesday")
        var perk = current.name || '';
        // Tier badge image temporarily hidden by business decision (2026-08-18).
        // Assets (tier-*.png) and badgeFor() are kept — to re-enable, prepend:
        //   '<img class="jp-rewards__badge" src="' + esc(badgeFor(current)) + '" alt="">' +
        void badgeFor; // keep helper referenced while the badge is hidden
        show('[data-jp-tier]',
          '<h3>' + esc(fmt(t.member_title, { tier: tierName(current) })) + '</h3>' +
          (perk ? '<p class="jp-rewards__perk">' + esc(perk) + '</p>' : ''));
        var pct;
        if (current.progress_percentage != null) {
          pct = Math.min(100, Number(current.progress_percentage));
        } else {
          var max = tiers[tiers.length - 1].spent_amount_required || 1;
          pct = Math.min(100, Math.round((spent / max) * 100));
        }
        show('[data-jp-progress]',
          '<h4 class="jp-eyebrow">' + esc(t.progress_title) + '</h4>' +
          '<div class="jp-rewards__bar"><span style="width:' + pct + '%"></span></div>' +
          '<div class="jp-rewards__milestones">' + tiers.map(function (x) {
            return '<span>' + esc(tierName(x)) + '</span>';
          }).join('') + '</div>' +
          '<p class="jp-rewards__spend">' + esc(fmt(t.spend, { amount: spent.toLocaleString() })) + '</p>' +
          '<p class="jp-rewards__hint">' + esc(t.progress_hint) + '</p>');
        if (data.point_balance != null) {
          show('[data-jp-points]', esc(fmt(t.points_balance, { points: Number(data.point_balance).toLocaleString() })));
        }
      })
      .catch(function () { show('[data-jp-error]', esc(t.error_loading)); });

    // 2) Points + rewards list
    fetch(api + '/api/shopify/get-available-reward?' + q + '&brands=' + encodeURIComponent(root.dataset.jpBrands))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var points = Number((data.user && data.user.point_balance) || 0);
        show('[data-jp-points]', esc(fmt(t.points_balance, { points: points.toLocaleString() })));
        var now = Date.now();
        var rewards = (data.rewards || []).filter(function (rw) {
          if (rw.availability != null && String(rw.availability) !== '1') return false;
          var s = parseDate(rw.display_start);
          var e = parseDate(rw.display_end);
          if (isNaN(s)) s = -Infinity;
          if (isNaN(e)) e = Infinity;
          return now >= s && now <= e;
        });
        if (!rewards.length) return;
        var accountUrl = window.location.origin + root.dataset.jpAccountUrl;
        show('[data-jp-list]',
          '<h4 class="jp-eyebrow">' + esc(t.available_rewards) + '</h4>' +
          '<ul class="jp-rewards__slider">' + rewards.map(function (rw, i) {
            var need = Number(rw.points_required || 0);
            var stockRaw = rw.total_quantity != null ? rw.total_quantity : rw.stock;
            var stock = (stockRaw == null || Number(stockRaw) < 0) ? null : Number(stockRaw);
            var unlocked = points >= need && (stock == null || stock > 0);
            var lines = [
              '<li class="jp-reward' + (unlocked ? '' : ' jp-reward--locked') + '" data-jp-reward="' + i + '">'
            ];
            if (rw.avatar) lines.push('<img class="jp-reward__image" src="' + esc(rw.avatar) + '" alt="" loading="lazy">');
            lines.push('<p class="jp-reward__title">' + esc(rw.name || '') + '</p>');
            lines.push('<p class="jp-reward__points">' + esc(fmt(t.points_required, { points: need })) + '</p>');
            if (stock != null) lines.push('<p class="jp-reward__stock">' + esc(fmt(t.stock_left, { count: stock })) + '</p>');
            var endTs = parseDate(rw.display_end);
            if (!isNaN(endTs) && endTs !== Infinity) {
              lines.push('<p class="jp-reward__valid">' + esc(fmt(t.valid_until, { date: new Date(endTs).toLocaleDateString() })) + '</p>');
            }
            if (rw.redeemable === true && rw.shopify_discount_code) {
              lines.push('<button type="button" class="button" data-jp-code="' + esc(rw.shopify_discount_code) + '">' + esc(t.redeem) + '</button>');
            } else if (rw.slug && rw.id) {
              lines.push('<a class="button" href="' + esc(api + '/' + rw.slug + '/exchange-rewards/' + rw.id + '?redirect=' + encodeURIComponent(accountUrl)) + '">' + esc(t.view_details) + '</a>');
            }
            if (!unlocked && need > points) {
              lines.push('<p class="jp-reward__more">' + esc(fmt(t.points_more, { points: need - points })) + '</p>');
            }
            lines.push('</li>');
            return lines.join('');
          }).join('') + '</ul>');
        root.querySelectorAll('[data-jp-code]').forEach(function (btn) {
          btn.addEventListener('click', function () { openCodeDialog(btn.dataset.jpCode); });
        });
      })
      .catch(function () { show('[data-jp-error]', esc(t.error_loading)); });

    function openCodeDialog(code) {
      var dlg = root.querySelector('[data-jp-dialog]');
      if (!dlg) return;
      dlg.innerHTML =
        '<h4 class="jp-eyebrow">' + esc(t.code_title) + '</h4>' +
        '<code class="jp-rewards__code">' + esc(code) + '</code>' +
        '<button type="button" class="button" data-jp-copy>' + esc(t.copy) + '</button>' +
        '<button type="button" class="jp-rewards__close" data-jp-close aria-label="' + esc(t.close || 'close') + '">&times;</button>';
      dlg.querySelector('[data-jp-copy]').addEventListener('click', function (e) {
        navigator.clipboard.writeText(code).then(function () { e.target.textContent = t.copied; });
      });
      dlg.querySelector('[data-jp-close]').addEventListener('click', function () { dlg.close(); });
      dlg.showModal();
    }
  });
})();

/* Cart voucher popup module ("YOUR REWARDS") — registered mount so the
   dialog shell survives cart-section morphs; shows at most once per page
   view. POST response verified empty-case as JSON "" (API_SAMPLES.md);
   data_voucher may be an object keyed by vendor OR an array —
   Object.values handles both. */
(function () {
  'use strict';
  var voucherShown = false;
  window.JPassport.registerMount(function mountVouchers() {
    var dlg = document.querySelector('[data-jp-vouchers]');
    if (!dlg || dlg.dataset.jpMounted === '1' || voucherShown) return;
    dlg.dataset.jpMounted = '1';
    var esc = window.JPassport.esc;
    var t = JSON.parse(dlg.dataset.jpT);

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return null;
        var brands = cart.items.map(function (i) { return i.vendor; })
          .filter(function (v, i, a) { return v && a.indexOf(v) === i; }).join(',');
        var body = new URLSearchParams({
          email: dlg.dataset.jpEmail,
          user_id: dlg.dataset.jpUserId,
          brands: brands
        });
        return fetch(dlg.dataset.jpApi + '/api/shopify/get-discount-code-collection', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.count || data.count < 1) return;
        var cards = [];
        Object.values(data.data_voucher || {}).forEach(function (v) {
          if (v && v.normal_voucher) cards.push(v.normal_voucher);
          ((v && v.offset_voucher) || []).forEach(function (o) { cards.push(o); });
        });
        if (!cards.length) return;
        voucherShown = true;
        dlg.innerHTML =
          '<h3>' + esc(t.title) + '</h3><p>' + esc(t.sub) + '</p>' +
          '<ul class="jp-vouchers__list">' + cards.map(function (c) {
            return '<li><span class="jp-vouchers__title">' + esc(c.title) + '</span>' +
                   '<code>' + esc(c.discount_code) + '</code>' +
                   '<button type="button" class="button" data-jp-vcopy="' + esc(c.discount_code) + '">' + esc(t.copy) + '</button></li>';
          }).join('') + '</ul>' +
          '<button type="button" class="button jp-vouchers__close" data-jp-vclose>' + esc(t.close) + '</button>';
        dlg.querySelectorAll('[data-jp-vcopy]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            navigator.clipboard.writeText(btn.dataset.jpVcopy).then(function () { btn.textContent = t.copied; });
          });
        });
        dlg.querySelector('[data-jp-vclose]').addEventListener('click', function () { dlg.close(); });
        dlg.showModal();
      })
      .catch(function () { /* voucher popup is best-effort; fail silent */ });
  });
})();

/* Mixed-cart pre-order warning module. The element is re-queried on every
   update — Horizon's cart morphs replace the DOM node, so caching it would
   toggle a detached element. Initial visibility is server-rendered by
   snippets/jpassport-cart-footer.liquid; this keeps it correct across AJAX
   cart changes. Intentionally shown to guests too (the shipping consequence
   applies regardless of login state; legacy gated it behind login). */
(function () {
  'use strict';
  window.JPassport.onCartUpdate(function (cart) {
    var el = document.querySelector('[data-jp-mixed-cart]');
    if (!el) return;
    var vendors = cart.items.map(function (i) { return i.vendor; })
      .filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    el.hidden = !(vendors.length > 1 && vendors.indexOf(el.dataset.jpPreorderVendor) > -1);
  });
})();
